import {UmpireImage} from '../umpire-image';
import {UmpireSquadStaffMember} from '../umpire-squad-staff-member';

export interface UmpireStaffMember {
  client_id: number;

  date_of_birth: string | null;

  country_code: string | null;

  first_name: string | null;

  id: string;

  last_name: string | null;

  relationshipNames: string[];

  short_name: string | null;

  instagram_url: string | undefined;

  facebook_url: string | undefined;

  spotify_url: string | undefined;

  twitter_url: string | undefined;

  type: string;

  image: UmpireImage;

  squad_staff_members: UmpireSquadStaffMember[];

  slug: string | null;
}
